import { useQuery } from 'react-query'
import { fetcher } from 'src/fetcher'
import { BASE_API_URL } from 'src/globals'
import { Partner } from 'src/types'

async function fetchPartners(): Promise<Partner[]> {
    const partners = await fetcher<any>(
        `${BASE_API_URL}/tmd-api/partners?apiVersion=v1`,
        undefined,
        'GET',
        {
            errorMsg: `Couldn't fetch partners for user`
        }
    )

    return partners
}

export const usePartners = () =>
    useQuery(['partners'], fetchPartners, {
        staleTime: 1000 * 60 * 60
    })
